import * as React from 'react';
import { connect, DispatchProp} from 'react-redux';
import { Dispatch, AnyAction } from 'redux';
import { ProgressBar, Alert, Grid, Row, Col } from 'react-bootstrap';
import *  as Types from './store/types'
import Header from './components/header';
import LoadCss from './components/loadcss';
import Form from './containers/form';
import './App.css';


type AppProps = Types.State & DispatchProp;


const App : React.SFC<AppProps> = props => {
    return (
      <div className="App">
        {loadCss(props)}
        <Header tableName={getTableName(props)} />
        <Grid>
          <Row>
          <Col xs={12}>
            {selectComponent(props)}
          </Col>
          </Row>
        </Grid>
      </div>
    );
}

function loadCss(props: AppProps) { 
     switch(props.loadingStep) { 
         case Types.LoadingStep.Loaded:
             // return (<LoadCss cssUrl="http://localhost/dev/dbi/odn/full/FU-1556711518-5cc9885e1d285/toto.css"/>);
             // return (<LoadCss cssUrl="http://localhost:3000/eeko.css"/>);
             return props.cssUid ? 
                 (<LoadCss cssUrl={props.apiUrl+"/css/"+props.cssUid}/>) :
                 [];
         default: 
             return [];
     }
}

function getTableName(props: AppProps) {
  switch(props.loadingStep) {
     case Types.LoadingStep.Loaded:
       return props.tableName;
      default:
        return "";
  }
}

function selectComponent(props: AppProps) {
  switch(props.loadingStep) {
    case Types.LoadingStep.NotLoaded:
      return <div>NotLoaded</div>;
    case Types.LoadingStep.Loading:
      return <div>Loading ...</div>; //<ProgressBar active now={0} />;
    case Types.LoadingStep.LoadError:
      return (
        <Alert bsStyle="danger">
           Error during api request: {props.error}
        </Alert>
       );
    case Types.LoadingStep.Loaded:
      return <Form {...props}/>
    default:
      return <div>Unsupported state</div>;
  }
}


const mapStateToProps = (state: Types.State) => state;
const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
  return {dispatch: dispatch};
};
export default connect(mapStateToProps,mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.tsx